import HotkeysPreferences from './HotkeysPreferences';

export default HotkeysPreferences;
